import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Button, ButtonKind } from "PFComponents/button";
import { ObjectWithProfileName } from "PFCore/helpers/profile";
import { useShortlistFill } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Shortlist } from "PFTypes";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type FillButtonProps = {
  disabled?: boolean;
  item: Shortlist;
  onSuccess?: VoidFunction;
  qaPrefix?: string;
  style?: any;
  isUnbiased?: boolean;
  kind: ButtonKind;
};

export const FillButton = ({
  disabled,
  style,
  onSuccess,
  qaPrefix = "",
  item,
  isUnbiased,
  kind
}: FillButtonProps) => {
  const { t } = useTranslation("activities");
  const { mutate: fillShortlist, isUpdating } = useShortlistFill();
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const { showGrowl } = useGrowlStoreActions();

  const handleClick = useCallback(() => {
    fillShortlist(
      { id: item.id },
      {
        onSuccess: () => {
          onSuccess?.();
          const name = getUnbiasedProfileName(item.profile as ObjectWithProfileName, isUnbiased);
          showGrowl({
            kind: "success",
            message: t("parts.roleFilledNotification", { name: name })
          });
        },
        onError: () => {
          showGrowl({
            kind: "error",
            message: t("parts.roleNotFilledError")
          });
        }
      }
    );
  }, [fillShortlist, item.id, item.profile, onSuccess, isUnbiased, t, showGrowl, getUnbiasedProfileName]);

  return (
    <Button
      text={t("parts.fillRole")}
      kind={kind || "primary"}
      style={style}
      disabled={disabled || isUpdating > 0}
      qaId={`${qaPrefix}-fill`}
      onClick={handleClick}
    />
  );
};
